import { KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

// The same sensor setup FirmSummaryWorkspace and EditColumnsPanel use: an 8px activation distance so
// a click on a control inside a row is not swallowed as a drag, plus keyboard reordering.
export const useDashboardSortableSensors = () =>
  useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );
